export default function () {

    const tree = document.getElementById('tree');

    if (!tree)
        return;

    tree.querySelectorAll('li.t0.parent').forEach(li => {
        const button = document.createElement('button');
        button.setAttribute('title', 'Rozwiń kategorię');

        li.appendChild(button);
    });

    tree.querySelectorAll('button').forEach(button => {
        button.addEventListener('click', function () {
            this.parentElement.classList.toggle('downarrow');
        });
    });
}

